import { groupBy } from 'lodash';

export function mapDataToClient(sensors) {
  return groupBy(sensors, sensor => sensor.displayName.split('-')[0]?.trim());
}

